import { createContext, useState } from "react";

export const alertContext = createContext();

const AlertProvider = (props)=>{
    const [alertConfig, setAlertConfig] = useState({
        show: false,
        message: '',
        type: ''
    });
    return (
        <alertContext.Provider value={[alertConfig, setAlertConfig]}>
            {props.children}
        </alertContext.Provider>
    );
}
export default AlertProvider;